import React from "react";

const useFilter = (data, dataSeter, options, placeHolder, compareKey) => {
  const handleChange = (e) => {
    console.log("value", e.target.value, data);
    const filteredData = data.filter((ele) => {
      if (e.target.value === compareKey) {
        return ele[compareKey] === true;
      } else {
        return ele[compareKey] === false;
      }
    });
    dataSeter(filteredData);
  };
  const Filter = () => {
    return (
      <>
        <select
          onChange={handleChange}
          style={{ padding: "18px", marginTop: "10px" }}
        >
          <option> {placeHolder} </option>
          {options?.length > 0 ? (
            options.map((option) => {
              return (
                <>
                  <option value={option.value}>{option.label}</option>
                </>
              );
            })
          ) : (
            <></>
          )}
        </select>
      </>
    );
  };

  return { Filter };
};

export default useFilter;
